import { create } from 'zustand'
import {
  extractStartParam,
  resolveStartParamRoute,
  persistStartParam,
  clearPersistedStartParam,
} from '@/utils/startParamRouting'

interface StartParamState {
  rawParam: string | null
  targetRoute: string | null
  consumed: boolean
  setParam: (param: string) => void
  markConsumed: () => void
  getPendingRoute: () => string | null
  reset: () => void
}

export const useStartParamStore = create<StartParamState>((set, get) => ({
  rawParam: null,
  targetRoute: null,
  consumed: false,

  setParam: (param: string) => {
    const route = resolveStartParamRoute(param)
    persistStartParam(param)
    set({ rawParam: param, targetRoute: route, consumed: false })
  },

  markConsumed: () => {
    clearPersistedStartParam()
    set({ consumed: true })
  },

  getPendingRoute: () => {
    const { targetRoute, consumed } = get()
    if (consumed || !targetRoute) return null
    return targetRoute
  },

  reset: () => {
    clearPersistedStartParam()
    set({ rawParam: null, targetRoute: null, consumed: false })
  },
}))

/**
 * Initializes the store by extracting the startparam from all available sources.
 * Call this once at app boot (from StartParamRouter).
 */
export function initStartParam(): void {
  const param = extractStartParam()
  if (param) {
    useStartParamStore.getState().setParam(param)
  }
}
